export enum StorageContainersEnum {
  ATTACHMENT = 'Attachment',
  IMAGE = 'Image'
}
